import Decimal from 'decimal.js-light';
import { formatNumber } from './format';

const hasValue = (value: unknown) => value !== null && value !== undefined && value !== '';

export function transactionMoney(value: unknown, currency: string, digits: number) {
  return hasValue(value)
    ? `${formatNumber(String(value), digits)} ${currency}`.trim()
    : '—';
}

export function transactionTotal(event: Record<string, any>) {
  if (['BUY', 'SELL', 'OPENING_BALANCE'].includes(event.eventType)) {
    const gross = hasValue(event.grossAmount)
      ? new Decimal(String(event.grossAmount))
      : hasValue(event.quantity) && hasValue(event.unitPrice)
        ? new Decimal(String(event.quantity)).mul(String(event.unitPrice))
        : null;
    if (!gross) return null;
    const charges = new Decimal(String(event.fee || 0)).add(String(event.tax || 0));
    const discount = new Decimal(String(event.discountAmount || 0));
    return (event.eventType === 'SELL'
      ? gross.sub(charges).add(discount)
      : gross.add(charges).sub(discount)).toString();
  }
  if (hasValue(event.cashAmount)) return String(event.cashAmount);
  return hasValue(event.grossAmount) ? String(event.grossAmount) : null;
}

export function transactionSettlement(event: Record<string, any>) {
  if (hasValue(event.cashAmount)) {
    return { amount: String(event.cashAmount), currency: String(event.cashCurrency || event.tradeCurrency || '') };
  }
  return {
    amount: transactionTotal(event),
    currency: String(event.tradeCurrency || event.cashCurrency || ''),
  };
}

export function exchangeDetails(event: Record<string, any>) {
  if (
    event.eventType !== 'BUY'
    || event.cashCurrency !== 'THB'
    || event.tradeCurrency !== 'USD'
    || !hasValue(event.cashAmount)
  ) return null;

  const rateToUsd = hasValue(event.fxRateToUsd) ? new Decimal(String(event.fxRateToUsd)) : null;
  if (!rateToUsd?.isPositive()) return null;
  const sourceAmount = new Decimal(String(event.cashAmount));
  const destinationAmount = hasValue(event.counterAmount)
    ? String(event.counterAmount)
    : sourceAmount.mul(rateToUsd).toString();
  return {
    sourceAmount: sourceAmount.toString(),
    sourceCurrency: 'THB',
    destinationAmount,
    destinationCurrency: 'USD',
    thbPerUsd: new Decimal(1).div(rateToUsd).toDecimalPlaces(8).toString(),
  };
}
